import React from 'react';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import store from 'store';
import isLoggedIn from '../helpers/isLoggedIn';
import { Redirect } from 'react-router-dom'

class Registration extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            today: new Date().toISOString().split('T')[0],
            gender: '',
            username: 'Unknown',
            password: '',
            error: false,
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    onSubmit() {
        const { username, password } = this.state;

        this.setState({ error: false });

        if (password === '' || username === '') {
            return this.setState({ error: true });
        }

        store.set('loggedIn', true);
        store.set('username', username);
    }

    render() {

        if (isLoggedIn()) {
            return <Redirect to="/dashboard" />;
        }

        return (
            <div>
                {/* <Grid container spacing={24}> */}
                <Paper className="registration form">
                    <div className="form-header">Registration form</div>
                    <div className="hw-form-inline-container with-label">
                        <FormControl>
                            <InputLabel htmlFor="age-simple">Gender</InputLabel>
                            <Select
                                value={this.state.gender}
                                onChange={this.handleChange('gender')}
                                label="gender"
                                input={<Input id="gender-simple" />}
                                className="hw-input inline select">
                                <MenuItem value={"M"}>Man</MenuItem>
                                <MenuItem value={"W"}>Woman</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            id="weight"
                            label="Weight (lbs)"
                            value={0}
                            onChange={this.handleChange('age')}
                            type="number"
                            className="hw-input inline"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                        <TextField
                            id="height"
                            label="Height (imperial)"
                            value="0"
                            // onChange={this.handleChange('age')}
                            type="number"
                            className="hw-input inline"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                        />
                    </div>
                    <TextField
                        placeholder="Username"
                        fullWidth={true}
                        className="hw-input"
                        onChange={this.handleChange('username')}
                    />
                    <TextField
                        placeholder="First Name"
                        fullWidth={true}
                        className="hw-input" />
                    <TextField
                        placeholder="Last Name"
                        fullWidth={true}
                        className="hw-input" />
                    <TextField
                        type="password"
                        placeholder="Password"
                        fullWidth={true}
                        className="hw-input"
                        onChange={this.handleChange('password')}
                    />
                    <TextField
                        type="password"
                        placeholder="Confirm Password"
                        fullWidth={true}
                        className="hw-input" />
                    <TextField
                        id="date"
                        label="Birthday"
                        type="date"
                        className="hw-input with-label"
                        defaultValue={this.state.today}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <Button raised color="primary" className="hw-primary-btn" onClick={this.onSubmit}>Create Account</Button>
                </Paper>
            </div>
        )
    };
}

export default Registration;


// WEBPACK FOOTER //
// ./src/components/Registration.js